export class TrackTagStore {
  private tags = new Map<number, string>();

  set(id: number, name: string): void {
    const trimmed = name.trim();
    if (trimmed.length === 0) {
      this.tags.delete(id);
    } else {
      this.tags.set(id, trimmed);
    }
  }

  get(id: number): string | undefined {
    return this.tags.get(id);
  }

  entries(): ReadonlyMap<number, string> {
    return this.tags;
  }

  drop(ids: readonly number[]): void {
    for (const id of ids) this.tags.delete(id);
  }

  clear(): void {
    this.tags.clear();
  }

  size(): number {
    return this.tags.size;
  }
}
